//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import HrIndicatorListView from '@/views/HumanResource/HrPrevisionIndicator/HrIndicatorList'
import CreatePrevisionIndicators from '@/views/HumanResource/HrPrevisionIndicator/CreatePrevisionIndicators'
import DetailsPrevisionIndicators from '@/views/HumanResource/HrPrevisionIndicator/details/DetailsPrevisionIndicators'

//
export default {
    path: 'prevision_indicators',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'prevision-indicator-list',
            component: HrIndicatorListView,
        },
        {
            path: 'create',
            name: 'prevision-indicator-create',
            component: CreatePrevisionIndicators,
        },
        {
            path: ':id',
            name: 'prevision-indicator-update',
            component: DetailsPrevisionIndicators,
        },
    ],
    meta: {
        title: 'Indicadores previsionales',
    },
}
